import { useQuery } from 'react-query';
import * as SettingApis from 'apis/setting';
import { AxiosError } from 'axios';

export type ICompany = SettingApis.FetchProfileResponse['company'];
export type IEmployee = SettingApis.FetchProfileResponse['employee'];
export type IEmployeeWallet =
  SettingApis.FetchProfileResponse['employee']['employee_wallets'][0];
export type ICompanyWalletConfiguration =
  SettingApis.FetchProfileResponse['company']['company_wallet_configurations'][0];
export type IEmployeeSettings =
  SettingApis.FetchProfileResponse['employee']['settings'];
export type IWalletType =
  SettingApis.FetchProfileResponse['employee']['employee_wallets'][0]['wallet_type'];
export type ICompanyLocation =
  SettingApis.FetchProfileResponse['company']['settings']['location'][0];

const getProfile = async () => {
  const {
    data: { company, employee },
  } = await SettingApis.fetchProfile();
  return { company, employee };
};

const useQueryProfile = ({
  is_logged_in,
  onSuccess,
  onError,
}: {
  is_logged_in: boolean;
  onSuccess?: (payload: { employee: IEmployee; company: ICompany }) => void;
  onError?: (e: AxiosError) => void;
}) => {
  const {
    data,
    isLoading: is_loading,
    refetch,
  } = useQuery(['getProfile'], () => getProfile(), {
    enabled: !!is_logged_in,
    onSuccess,
    onError,
  });

  return {
    data,
    is_loading,
    refetch,
  };
};

export default useQueryProfile;
